module.exports = __webpack_public_path__ + "img/无人值守.c381b741.jpg";